import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators,FormBuilder } from '@angular/forms';
import { User } from '@app/_models';
import { AuthenticationService } from '@app/_services';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '@app/_modal';
import { MustMatch } from '@app/_helpers/must-match.validator';
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  currentUser: User;
  signupForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error = '';
  bHasFile:boolean=false;
  private sub: any;
  category:string='';
  constructor(
    private modalService: ModalService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.sub = this.route.params.subscribe(params => {
      this.category=params['cat'];
    });
    this.signupForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['',  [Validators.required, Validators.email]],
      password: ['', Validators.required],
      telephone:'',
      confirmPwd: ['', Validators.required],
      profpicfile:"",
      userPhoto:"",
    },{
      validator: MustMatch('password', 'confirmPwd')
  });
  }
  get f() { return this.signupForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.signupForm.invalid) {
        return;
    }
    this.currentUser = Object.assign({}, this.signupForm.value);
    this.currentUser.username= this.currentUser.email;
    this.currentUser.userType=this.category;
    this.loading = true;
    this.authenticationService.signup(this.currentUser)
        .pipe(first())
        .subscribe(
            data => {
              if(this.category=='2'){
                this.modalService.close("signup");
                this.router.navigate(['/agents/clients']);
              }
              else {
                this.router.navigate(['/']); //this.router.navigate([this.returnUrl]);
              }
            },
            error => {
                this.error = error;
                this.loading = false;
        });
  }
  triggerInput() {
    $('#profpicfile').trigger('click');
  }
  onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
        this.bHasFile=true;
        let reader = new FileReader();
        let file = event.target.files[0];
        this.signupForm.get('profpicfile').setValue(file);
        reader.readAsDataURL(file);
        reader.onload = () => {
            $('#profpic')
                .find('img')
                .attr('src', reader.result as string);
        };
    }
  }
  closeModal() {
    this.modalService.close("help");
}
}
